import { ApexOptions } from 'apexcharts';
import { formatUTCDateToLocal, unixTimestampToISO8601 } from 'src/utilities';

export const ADD_CHART_BTN_TEXT = 'Add Chart';
export const POINT_CHARTS_LOCAL_STORAGE_KEY = 'pointCharts';
export const SEPARATOR = '(sep)';

export const AXIS_DEFAULT_COLORS = [
  '#32DFB6',
  '#7E5CC6',
  '#FC8B8B',
  '#F5CB35',
  '#4C78A8',
  '#F58518',
  '#54A24B',
  '#9D755D',
  '#BAB0AC',
  '#E4572E',
];

// Cycles back to the start of the palette once there are more axes than colors.
export const getDefaultAxisColor = (index: number) =>
  AXIS_DEFAULT_COLORS[index % AXIS_DEFAULT_COLORS.length];

// Picks the first palette color that isn't already used by an existing axis.
// Assigning by row count alone can reuse a color when an earlier row was
// removed (e.g. delete the 1st of 2 rows, then add a new one). Falling back to
// the count keeps cycling through the palette once every color is taken.
export const getNextAvailableAxisColor = (usedColors: string[]) => {
  const used = new Set(usedColors);
  const free = AXIS_DEFAULT_COLORS.find((color) => !used.has(color));
  return free ?? getDefaultAxisColor(usedColors.length);
};

export const getChartOptions = (): ApexOptions => ({
  chart: {
    stacked: false,
    id: 'basic-bar-2',
    type: 'scatter',
    zoom: {
      type: 'xy',
    },
    toolbar: {
      autoSelected: 'zoom',
      tools: {
        download: false,
      },
    },
    animations: {
      enabled: false,
    },
    redrawOnParentResize: false,
    redrawOnWindowResize: false,
  },
  dataLabels: {
    enabled: false,
  },
  yaxis: {
    labels: {
      formatter: function (val) {
        return val.toFixed(1);
      },
    },
  },
  xaxis: {
    type: 'datetime',
    labels: {
      datetimeUTC: false,
      showDuplicates: false,
      format: 'MMM d yyyy hh:mmtt',
    },
  },
  markers: {
    size: 3,
  },
  tooltip: {
    x: {
      show: true,
      formatter: function (val) {
        return formatUTCDateToLocal(false, unixTimestampToISO8601(val / 1000));
      },
    },
    y: {
      formatter: function (val) {
        return val.toFixed(1);
      },
      title: {
        formatter: (seriesName) => seriesName,
      },
    },
  },
  legend: {
    formatter: (legendName) => legendName,
    showForSingleSeries: true,
    offsetY: 0,
    position: 'top',
    horizontalAlign: 'left',
  },
});
